import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { useAuth } from './auth';

const ProtectedRoute = ({ element: Component, ...rest }) => {
    const user = localStorage.getItem("adminAccessToken");

    return user ? <Component {...rest} /> : <Navigate to="/" />;
};

export default ProtectedRoute;
